import axios from 'axios'

class ReportFactory {
  async exportBalanceSheet (data: any) {
    try {
      const url = '/acc/reports/balance_sheet'
      const response = await axios.get(url, {
        responseType: 'arraybuffer',
        params: {
          date_from: data.date_from,
          date_to: data.date_to
        }
      })
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'Laporan_Neraca.xlsx'
      link.click()
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async exportIncomeSummary (data: any) {
    try {
      const url = '/acc/reports/income_summary'
      const response = await axios.get(url, {
        responseType: 'arraybuffer',
        params: {
          date_from: data.date_from,
          date_to: data.date_to
        }
      })
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'Laporan_Laba_Rugi.xlsx'
      link.click()
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async exportPrepaidIncome (data: any) {
    try {
      const url = '/acc/reports/prepaid_income'
      const response = await axios.get(url, {
        responseType: 'arraybuffer',
        params: {
          date_from: data.date_from,
          date_to: data.date_to
        }
      })
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'Laporan_Pendapatan_Dibayar_di_Muka.xlsx'
      link.click()
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async exportPettyCashAdvance (data: any) {
    try {
      const url = '/acc/reports/petty_cash_advance'
      const response = await axios.get(url, {
        responseType: 'arraybuffer',
        params: {
          date_from: data.date_from,
          date_to: data.date_to
        }
      })
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'Laporan_Kas_Bon_Sementara.xlsx'
      link.click()
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async exportCashFlow (data: any) {
    try {
      const url = '/acc/reports/cash_flow'
      const response = await axios.get(url, {
        responseType: 'arraybuffer',
        params: {
          date_from: data.date_from,
          date_to: data.date_to
        }
      })
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'Laporan_Arus_Kas.xlsx'
      link.click()
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async exportCashFlowAccount (data: any) {
    try {
      const url = '/acc/reports/cash_flow_account'
      const response = await axios.get(url, {
        responseType: 'arraybuffer',
        params: {
          date_from: data.date_from,
          date_to: data.date_to,
          acc_account_id: data.acc_account_id
        }
      })
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'Laporan_Arus_Kas.xlsx'
      link.click()
    } catch (error) {
      console.error(error)
      return false
    }
  }
}

export const reportFactory = new ReportFactory()
